export default __webpack_public_path__ + "static/media/no-data-icon.fe53f51c.jpg";